// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"CorporateThankYouPage_mainWrapper__1PrIs","thankyouWrapper":"CorporateThankYouPage_thankyouWrapper__3qX8j","btnDone":"CorporateThankYouPage_btnDone__PYQNz"};